import { iCarousel } from "./interfaces/carousel-plans";

const CarouselPlans: iCarousel[] = [
  {
    link: "",
    title: "Vem ser iTop",
    imgDesktop: "images/plans/confie_desktop.png",
    imgMobile: "images/plans/confie_mobile.png",
    video: "",
    cities: [],
  },
  {
    link: "",
    title: "Promoção - Plano Essencial Smart 700 MB",
    imgDesktop: "images/plans/plano_smart_desk.png",
    imgMobile: "images/plans/plano_smart_mobile.png",
    video: "",
    cities: [
      { city: "Alfenas", uf: "MG" },
      { city: "Areado", uf: "MG" },
      { city: "Inhaúma", uf: "MG" },
      { city: "Machado", uf: "MG" },
      { city: "Paraguaçu", uf: "MG" },
      { city: "Sete Lagoas", uf: "MG" },
    ],
  },
  {
    link: "",
    title: "Promoção - Plano 700 MB ",
    imgDesktop: "images/plans/700_mb_BH_RB_desktop.png",
    imgMobile: "images/plans/700_mb_BH_RB_mobile.png",
    video: "",
    cities: [
      { city: "Ribeirão Preto", uf: "SP" },
      { city: "Belo Horizonte", uf: "MG" },
    ],
  },
  {
    link: "https://itop.net.br/alerta-golpe",
    title: "",
    imgDesktop: "images/plans/banner_pix_desk.png",
    imgMobile: "images/plans/banner_pix_mobile.png",
    video: "",
    cities: [],
  },
];
export default CarouselPlans;
